const KIND_OPTIONS = [
  { value: "", label: "All" },
  { value: "FARMER", label: "Farmer" },
  { value: "BROKER", label: "Broker" },
  { value: "DEALER", label: "Dealer" },
  { value: "BUYER", label: "Buyer" },
  { value: "SUPPLIER", label: "Supplier" },
  { value: "LABOUR_CONTRACTOR", label: "Labour contractor" },
  { value: "TRANSPORTER", label: "Transporter / truck owner" },
  { value: "OTHER", label: "Other" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
function partyKinds(row) {
  if (Array.isArray(row?.kinds) && row.kinds.length) return row.kinds;
  return row?.kind ? [row.kind] : [];
}

export const PARTY_COLUMNS = [
  {
    id: "kind",
    label: "Kind",
    accessor: (row) => partyKinds(row).join(" · "),
    filterType: "select",
    filterOptions: KIND_OPTIONS,
    serverParam: "kind",
    matchFilter: (row, value) => !value || partyKinds(row).includes(value),
  },
  { id: "display_name", label: "Name", accessorKey: "display_name", filterType: "text" },
  { id: "phone", label: "Phone", accessorKey: "phone", filterType: "text" },
  { id: "city", label: "City", accessorKey: "city", filterType: "text" },
  { id: "gstin", label: "GSTIN", accessorKey: "gstin", filterType: "text" },
  { id: "email", label: "Email", accessorKey: "email", filterType: "text" },
  {
    id: "is_active",
    label: "Status",
    serverParam: "status",
    accessor: (row) => (row.is_active ? "Active" : "Inactive"),
    filterType: "select",
    filterOptions: [
      { value: "all", label: "All" },
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ],
    matchFilter: (row, value) => {
      if (!value || value === "all") return true;
      return value === "active" ? row.is_active : !row.is_active;
    },
  },
];
